import styled, {css} from 'styled-components';

const disabledOpacity = 0.4;
const checkBoxSize = {
  width: '24px',
  height: '24px',
};

type CheckboxWrapperProps = {
  disabled?: boolean;
};

export const CheckboxWrapper = styled.div<CheckboxWrapperProps>`
  font-family: Poppins, sans-serif;
  cursor: pointer;
  column-gap: 12px;
  text-align: left;
  min-width: 225px;
  display: flex;
  color: #161643;
  align-items: center;

  & div {
    width: '${checkBoxSize.width}';
    /* height: ${checkBoxSize.height}; */
  }

  ${props =>
    props.disabled &&
    css`
      opacity: ${disabledOpacity};
      cursor: not-allowed;
    `};
`;

export const AcceptIconImg = styled.img`
  user-select: none;
  width: 22px;
  height: 18px;
`;

export const CheckedRoundCheckbox = styled.div`
  background-color: #3b71fe;
  border-radius: 50%;
  width: 14px;
  height: 14px;
`;

type BoxProps = {
  disabled?: boolean;
  checked?: boolean;
  round?: boolean;
};

export const Box = styled.div<BoxProps>`
  width: ${checkBoxSize.width};
  height: ${checkBoxSize.height};
  box-sizing: border-box;
  position: relative;
  text-align: center;
  transition: all 0.1s ease-in-out;
  border: ${props => (props.checked ? '2px solid #2148ff;' : '2px solid #e6e8ec')};
  border: ${props => (props.round ? '2px solid #e6e8ec;' : '2px solid #e6e8ec')};
  background-color: ${props => (props.checked ? '#ffffff' : '#fcfcfd')};
  border-radius: ${props => (props.round ? '50%' : '6px')};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: ${props => props.disabled && disabledOpacity};
  cursor: pointer;
`;

export const Label = styled.span`
  user-select: none;
  vertical-align: middle;
  font-family: Poppins, sans-serif;
`;
